import {
  requireBoolean,
  requireExactKeys,
  requireRecord,
} from "./validation";

export interface ClientCapabilities {
  readonly videoDownloadV1: boolean;
}

export type ShareCapabilities = ClientCapabilities;

export const DISABLED_CLIENT_CAPABILITIES: ClientCapabilities = Object.freeze({
  videoDownloadV1: false,
});

export interface ShareGrant {
  readonly shareId: string;
  readonly access: "view" | "download";
  readonly canContribute?: boolean;
  readonly viewerRecipientId?: string;
  readonly expiresAt: string;
  readonly capabilities: ShareCapabilities;
}

export function parseClientCapabilities(
  value: unknown,
  path = "$",
): ClientCapabilities {
  const record = requireRecord(value, path);
  requireExactKeys(record, ["videoDownloadV1"], [], path);
  return {
    videoDownloadV1: requireBoolean(
      record.videoDownloadV1,
      `${path}.videoDownloadV1`,
    ),
  };
}

export interface EffectiveVideoCapabilityInput {
  readonly globalPolicyEnabled?: boolean;
  readonly ownerCohortEnabled?: boolean;
  readonly ownerClientSupports?: boolean;
  readonly viewerClientSupports?: boolean;
  readonly access?: "view" | "download";
}

export function hasEffectiveVideoDownloadV1(
  input: EffectiveVideoCapabilityInput,
): boolean {
  return input.globalPolicyEnabled === true
    && input.ownerCohortEnabled === true
    && input.ownerClientSupports === true
    && input.viewerClientSupports === true
    && input.access === "download";
}
